import "@/App.css";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import RequireAuth from "@/components/RequireAuth";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Employees from "@/pages/Employees";
import Users from "@/pages/Users";
import PayRunList from "@/pages/PayRunList";
import PayRun from "@/pages/PayRun";
import PayRunApprove from "@/pages/PayRunApprove";
import PayRunSuccess from "@/pages/PayRunSuccess";
import PayrollSettings from "@/pages/PayrollSettings";
import PublicHolidays from "@/pages/PublicHolidays";
import SetupEmployees from "@/pages/SetupEmployees";
import IrcS2 from "@/pages/IrcS2";
import IrcS1 from "@/pages/IrcS1";
import IrcS6 from "@/pages/IrcS6";
import UploaderWorkspace from "@/pages/UploaderWorkspace";

function Protected({ children, adminOnly = false }) {
    return (
        <RequireAuth adminOnly={adminOnly}>
            <AppLayout>{children}</AppLayout>
        </RequireAuth>
    );
}

function NotFound() {
    return (
        <div className="p-10 max-w-2xl" data-testid="not-found-page">
            <div className="text-[11px] uppercase tracking-[0.24em] text-neutral-500 font-display">404</div>
            <h1 className="font-display font-bold text-4xl mt-1 text-[color:var(--kp-charcoal)]">
                Nothing to see here.
            </h1>
            <p className="text-sm text-neutral-500 mt-1">
                That page doesn&rsquo;t exist. Try the dashboard or the pay-run list.
            </p>
            <div className="mt-6 flex gap-3">
                <Link to="/" className="px-4 py-2 text-[12px] font-display font-semibold uppercase tracking-[0.12em] text-white rounded-[3px]" style={{ background: "var(--kp-red)" }}>
                    Back to dashboard
                </Link>
                <Link to="/pay-runs" className="px-4 py-2 text-[12px] font-display font-semibold uppercase tracking-[0.12em] border border-neutral-300 text-neutral-700 rounded-[3px]">
                    Pay runs
                </Link>
            </div>
        </div>
    );
}

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/uploader" element={
                            <RequireAuth uploaderAllowed>
                                <UploaderWorkspace />
                            </RequireAuth>
                        } />
                        <Route path="/" element={<Protected><Dashboard /></Protected>} />
                        <Route path="/pay-runs" element={<Protected><PayRunList /></Protected>} />
                        <Route path="/pay-runs/:id" element={<Protected><PayRun /></Protected>} />
                        <Route path="/pay-runs/:id/approve" element={<Protected adminOnly><PayRunApprove /></Protected>} />
                        <Route path="/pay-runs/:id/complete" element={<Protected><PayRunSuccess /></Protected>} />
                        <Route path="/employees" element={<Protected><Employees /></Protected>} />
                        <Route path="/settings/users" element={<Protected adminOnly><Users /></Protected>} />
                        <Route path="/settings/payroll" element={<Protected><PayrollSettings /></Protected>} />
                        <Route path="/settings/holidays" element={<Protected><PublicHolidays /></Protected>} />
                        <Route path="/setup/employees" element={<Protected adminOnly><SetupEmployees /></Protected>} />
                        <Route path="/reports/irc-s2" element={<Protected><IrcS2 /></Protected>} />
                        <Route path="/reports/irc-s1" element={<Protected><IrcS1 /></Protected>} />
                        <Route path="/reports/irc-s6" element={<Protected><IrcS6 /></Protected>} />
                        <Route path="*" element={<Protected><NotFound /></Protected>} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
